// Vistos do registo do site (26/10/2026). Sem sessão até confirmar o email, a
// aceitação fica marcada neste navegador e é registada na BD no 1.º acesso
// (consentimentoPoliticas.ts). Separado para o AuthProvider não carregar o
// cliente Supabase só por isto.

const CHAVE_REGISTO = 'tamoaki_politicas_registo'

export function marcarAceitacaoNoRegisto(): void {
  try { localStorage.setItem(CHAVE_REGISTO, new Date().toISOString()) } catch { /* pede no aviso */ }
}

export function aceitouNoRegisto(): boolean {
  try { return !!localStorage.getItem(CHAVE_REGISTO) } catch { return false }
}

export function limparAceitacaoNoRegisto(): void {
  try { localStorage.removeItem(CHAVE_REGISTO) } catch { /* idem */ }
}
